import { Helmet } from 'react-helmet';

const SITE_URL = 'https://bettersleep.ing';
const SITE_NAME = 'BetterSleep';

const SEOHead = ({
    title,
    description,
    path = '/',
    image,
    type = 'website',
    publishedAt,
    updatedAt,
    author,
    category,
    keywords,
    article = false,
}) => {
    const fullUrl = `${SITE_URL}${path}`;
    const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} - Transform Your Sleep, Transform Your Life`;
    const metaDescription = description || 'Science-backed sleep solutions and expert advice for better rest.';

    const jsonLd = article ? {
        '@context': 'https://schema.org',
        '@type': 'Article',
        'headline': title,
        'description': metaDescription,
        'url': fullUrl,
        'image': image || undefined,
        'datePublished': publishedAt || undefined,
        'dateModified': updatedAt || publishedAt || undefined,
        'author': {
            '@type': 'Person',
            'name': author || SITE_NAME,
        },
        'publisher': {
            '@type': 'Organization',
            'name': SITE_NAME,
            'url': SITE_URL,
            'logo': {
                '@type': 'ImageObject',
                'url': `${SITE_URL}/logo512.png`,
            },
        },
        'mainEntityOfPage': {
            '@type': 'WebPage',
            '@id': fullUrl,
        },
        ...(category ? { 'articleSection': category } : {}),
        ...(keywords ? { 'keywords': keywords } : {}),
    } : null;

    return (
        <Helmet>
            <title>{fullTitle}</title>
            <meta name="description" content={metaDescription} />
            <link rel="canonical" href={fullUrl} />

            {keywords && <meta name="keywords" content={keywords} />}

            {/* Open Graph */}
            <meta property="og:type" content={article ? 'article' : type} />
            <meta property="og:title" content={title || fullTitle} />
            <meta property="og:description" content={metaDescription} />
            <meta property="og:url" content={fullUrl} />
            <meta property="og:site_name" content={SITE_NAME} />
            <meta property="og:locale" content="en_US" />
            {image && <meta property="og:image" content={image} />}
            {image && <meta property="og:image:width" content="1792" />}
            {image && <meta property="og:image:height" content="1024" />}

            {/* Article specific OG */}
            {publishedAt && <meta property="article:published_time" content={publishedAt} />}
            {updatedAt && <meta property="article:modified_time" content={updatedAt} />}
            {category && <meta property="article:section" content={category} />}

            {/* Twitter Card */}
            <meta name="twitter:card" content={image ? 'summary_large_image' : 'summary'} />
            <meta name="twitter:title" content={title || fullTitle} />
            <meta name="twitter:description" content={metaDescription} />
            {image && <meta name="twitter:image" content={image} />}

            {/* JSON-LD Structured Data */}
            {jsonLd && (
                <script type="application/ld+json">
                    {JSON.stringify(jsonLd)}
                </script>
            )}
        </Helmet>
    );
};

export default SEOHead;
